import React, { useContext } from "react";
import { LoggerContext } from "context/LoggerContext";
import styles from './FormSection.module.scss';
import SectionWrapper from "components/elements/SectionWrapper";
import DynamicForm from "components/elements/DynamicForm/DynamicForm";

const FormSection = (props) => {
	const { logDebug } = useContext(LoggerContext);
	
	// Debug form props
	logDebug("FormSection received props:", {
		hasForm: !!props.form,
		formTitle: props.form?.title,
		formType: props.form?.type_id,
		formKeys: Object.keys(props.form || {})
	});

	console.log("propspropspropsprops11111", props);

	return (
		<SectionWrapper 
			className={`${styles.FeatureSection}`} 
			fluid={false} 
			{...props}
		>
			{props.form ? (
				<DynamicForm {...props} />
			) : (
				<div className="alert alert-warning">
					<h4>Form could not be loaded</h4>
					<p>The form data is missing or invalid. Please check the console for more information.</p>
				</div>
			)}
		</SectionWrapper>
	);
};

export default FormSection;